<template>
  <Layout>
    <div class="banner-page">
      <img :src="'/img/program-banner.jpg'" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <router-link :to="`/cari-masjed`">Cari Masjed</router-link>
          </li>
          <li>
            <router-link :to="`/donasi-masjed-pembayaran`"
              >Pembayaran</router-link
            >
          </li>
          <li>
            <router-link :to="`/donasi-masjed-metode-pembayaran`"
              >Metode Pembayaran</router-link
            >
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section pembayaran">
      <div class="container">
        <div class="main-content bg-white">
          <form
            class="standar-form payment-after-action"
            action="javascript:void(0)"
            @submit.prevent="submit"
          >
            <div class="nominal-label">
              <div class="nominal-text">Nominal Sedekah</div>
              <div class="nominal-value">
                Rp.
                <span>{{ nominalDonasi | numeral('0,  0') | rupiah }}</span>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="special-label">
              Pilih Metode Pembayaran
            </div>

            <payment-box></payment-box>

            <div class="form-group mt-5">
              <button
                type="submit"
                class="btn btn-cta btn-full mt-1"
                :disabled="submitStatus"
              >
                {{ submitText }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../views/layouts/Index.vue';
import axiosmasjid from '../utils/apimasjid';
import axios from '../utils/api';
import PaymentBox from '../components/payment/MasjedPayment.vue';

import { mapState, mapActions } from 'vuex';

export default {
  components: {
    Layout,
    PaymentBox,
  },
  name: 'danai',
  data() {
    return {
      data: [],
      submitStatus: false,
      submitText: 'Bayar',
      novirtual: 'XXXXXX',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchDetail();
    window.history.forward(1);
  },
  computed: {
    ...mapState('transactions', [
      'idmasjid',
      'paymentId',
      'programTitle',
      'nominalDonasi',
      'userData',
    ]),
  },
  methods: {
    ...mapActions('transactions', ['setPaymentResponse']),
    async fetchDetail() {
      const { slug } = this.$router.history.current.params;
      const detail = await axios.get(`/detailcampaign?slug=${slug}`);
      const { campaign } = detail.data.data;

      this.data = campaign;
    },
    async submit() {
      var formData = new FormData();
      formData.append('Transaksi[idcampprog]', this.idmasjid);
      formData.append('Transaksi[nominal]', this.nominalDonasi);
      formData.append('Transaksi[bank]', this.paymentId);
      formData.append('Transaksi[typecampprog]', 'SEDEKAH_MASJID');
      formData.append(
        'Transaksi[namaDonatur]',
        this.userData.namaDonatur || ''
      );
      formData.append(
        'Transaksi[emailDonatur]',
        this.userData.emailDonatur || ''
      );
      formData.append(
        'Transaksi[telpDonatur]',
        this.userData.teleponDonatur || ''
      );
      formData.append('Transaksi[comment]', this.userData.doaDonatur || '');

      this.submitStatus = true;
      this.submitText = 'Sedang Diproses...';

      const result = await axiosmasjid.post('/default/createtrx', formData);

      this.submitStatus = false;
      this.submitText = 'Bayar';

      this.setPaymentResponse(result.data);

      const { no_va, qris, landing_page } = result.data.data;
      if (no_va === null && qris === null) {
        window.open(landing_page);
      }
      this.$router.push({ name: 'donasi-informasi-pembayaran' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'scss/payment-action';
</style>
